import Screensize from "../ui/Screensize"
import "./fonts/stylesheet.css"

const defaultStyles = {
  fontSize: 18,
  fontWeight: 400,
  lineHeight: "1.3em"
}

const freightFont = {
  fontFamily: "FreightText, Georgia, serif"
}

const proximaFont = {
  fontFamily: "ProximaNova, sans-serif"
}

export const heading1 = (props) => ({
  ...defaultStyles,
  ...proximaFont,
  fontSize: Screensize.select({ sm: 36.75, md: 39, lg: 42 })(props),
  fontWeight: 300
})

export const heading2 = (props) => ({
  ...defaultStyles,
  ...proximaFont,
  fontSize: Screensize.select({ sm: 31.5, md: 33.75, lg: 36 })(props),
  fontWeight: 700
})

export const heading3 = (props) => ({
  ...defaultStyles,
  ...proximaFont,
  fontSize: Screensize.select({ sm: 28, md: 30, lg: 32 })(props),
  fontWeight: 400
})

export const heading4 = (props) => ({
  ...defaultStyles,
  ...proximaFont,
  fontSize: Screensize.select({ sm: 21, md: 22.5, lg: 24 })(props),
  fontWeight: 700
})

export const heading5 = (props) => ({
  ...defaultStyles,
  ...proximaFont,
  fontSize: Screensize.select({ sm: 17.5, md: 18.75, lg: 20 })(props),
  fontWeight: 700
})

export const heading6 = (props) => ({
  ...defaultStyles,
  ...proximaFont,
  fontSize: Screensize.select({ sm: 14, md: 15, lg: 16 })(props),
  fontWeight: 700
})

export const blockquote = (props) => ({
  ...defaultStyles,
  ...freightFont,
  fontSize: Screensize.select({ sm: 21, md: 22.5, lg: 24 })(props),
  fontStyle: "italic",
  borderLeftWidth: 1,
  borderLeftStyle: "solid",
  padding: "10px 20px",
  margin: "20px 0",
  "& p:first-of-type": {
    marginTop: 0
  },
  "& p:last-child": {
    marginBottom: 0
  }
})

export const a = (props) => ({
  overflowWrap: "break-word",
  wordWrap: "break-word",
  wordBreak: "break-word"
})

export const body = (props) => ({
  ...defaultStyles,
  ...freightFont,
  fontSize: Screensize.select({ sm: 17.5, md: 18.75, lg: 20 })(props)
})

export const small = (props) => ({
  ...defaultStyles,
  ...freightFont,
  fontSize: Screensize.select({ sm: 14, md: 15, lg: 16 })(props)
})

// If used in Chakra css prop, we must '& ' to all selectors.
export const contentStyles = (props) => {
  const styles = {
    "&": body(props),
    "& h1": heading1(props),
    "& h2": heading2(props),
    "& h3": heading3(props),
    "& h4": heading4(props),
    "& h5": heading5(props),
    "& h6": heading6(props),
    "& a": a(props),
    "& input": body(props),
    "& small": small(props),
    "& blockquote": blockquote(props),
    "& i, & em": { fontStyle: "italic" },
    "& b, & strong": { fontWeight: 700 },
    // "ol, ul": { paddingLeft: "1em" },
    // "ol li": { listStyleType: "decimal" },
    // "ul li": { listStyleType: "disc" },
    // li: { margin: "5px 0" },
    "& > *:first-of-type": { marginTop: 0 },
    "& > *:last-child": { marginBottom: 0 }
  }
  return {
    ...styles,
    // TODO: probably apply these styles differently
    "& .BlockText": styles,
    "&.ql-container, textarea": styles
  }
}
